
import { computed, defineComponent, PropType } from "vue";
import { PPTRectElement, ShapeText } from "@/types/slides";
import useElementShadow from "@/views/components/element/hooks/useElementShadow";
import useElementFlip from "@/views/components/element/hooks/useElementFlip";

import GradientDefs from "./GradientDefs.vue";
import tinycolor from "tinycolor2";
export default defineComponent({
  name: "base-element-Rect",
  components: {
    GradientDefs,
  },
  props: {
    elementInfo: {
      type: Object as PropType<PPTRectElement>,
      required: true,
    },
  },
  setup(props) {
    const shadow = computed(() => props.elementInfo.shadow);
    const { shadowStyle } = useElementShadow(shadow);

    const flipH = computed(() => props.elementInfo.flipH);
    const flipV = computed(() => props.elementInfo.flipV);
    const { flipStyle } = useElementFlip(flipH, flipV);

    const text = computed<ShapeText>(() => {
      const defaultText: ShapeText = {
        content: "",
        defaultFontSize:'20px',
        defaultFontName: "Noto Sans S Chinese Regular",
        defaultColor: "#000",
        align: "middle",
      };
      if (!props.elementInfo.text) return defaultText;

      return props.elementInfo.text;
    });
    return {
      shadowStyle,
      flipStyle,
      text,
      tinycolor,
    };
  },
});
